<div class="d-flex flex-row justify-content-center">
  <div
    class="d-flex flex-column gap-2 align-items-center justify-content-center"
    style="width: 85%"
  >
    <div
      class="bg-primary-light p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
      style="width: 100px; height: 100px"
    >
      <div
        class="bg-primary p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
        style="width: 75px; height: 75px"
      >
        <div
          class="bg-primary-dark p-2 rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
          style="width: 50px; height: 50px"
        >
          <icon [icon]="iconCheck" size="50" color="primary-light" />
        </div>
      </div>
    </div>
    <span class="fs-5 text-center fw-semibold"
      >{{ "app.pageId.claim.preauthorization-created" | translate }}</span
    >
    <p class="text-center fs-10 text-info">{{ message | translate}}</p>
    <div
      class="alert alert-info p-3 d-flex flex-column align-items-center justify-content-center w-100 gap-1"
    >
      <h4 class="fs-7 fw-normal mb-0">
        {{ "app.pageId.claim.preauthorization-number-label" | translate }}
      </h4>
      <div class="d-flex flex-row gap-1 align-items-center">
        <button-component [config]="copyClaimBtn" />
        <p class="fs-10 fw-bold mb-0">
          {{claimInfo?.preauthorization?.preauthorizedClaimNumber}}
        </p>
      </div>
    </div>
  </div>
</div>
